import { forwardRef } from 'react';

import { IconProps } from '@sternum/web/icons/icons.types';

export const AlignRightIcon = forwardRef<SVGSVGElement, IconProps>(function AlignRightIcon(
  { color = '', height = 12, width = 12, ...props },
  ref,
) {
  return (
    <svg ref={ref} width={width} height={height} viewBox="0 0 12 12" fill="none" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10 2.7127C10 2.31909 9.74416 2 9.42857 2H2.57143C2.25584 2 2 2.31909 2 2.7127C2 3.10632 2.25584 3.42541 2.57143 3.42541H9.42857C9.74416 3.42541 10 3.10632 10 2.7127ZM10 6C10 5.60639 9.74416 5.2873 9.42857 5.2873H7.14286C6.82727 5.2873 6.57143 5.60639 6.57143 6C6.57143 6.39362 6.82727 6.7127 7.14286 6.7127H9.42857C9.74416 6.7127 10 6.39362 10 6ZM10 9.2873C10 8.89368 9.74416 8.57459 9.42857 8.57459H4.85714C4.54155 8.57459 4.28571 8.89368 4.28571 9.2873C4.28571 9.68091 4.54155 10 4.85714 10H9.42857C9.74416 10 10 9.68091 10 9.2873Z"
        fill={color || 'currentColor'}
      />
    </svg>
  );
});
